export default {"src":"/_next/static/media/exclamation.4737c422.svg","height":20,"width":20};